import React, { useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { DialogAction, useModal } from '../../../../function/useModal';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ApiResponseCode, deleteIoTSet, IOT_SET, V_IOTBOX_SETTING_ITEM } from './IoTBoxSetting';
import { TableUseStyle, IoTBoxSettingStyle } from './IoTBoxSettingStyle';

export type IoTBoxSettingRowDelDialogProps = {
  dialog: DialogAction<IoTBoxSettingRowDelDialogResponse>;
  item: V_IOTBOX_SETTING_ITEM | undefined;
  //devNoCombos: ComboBoxItemType[] | undefined;
};

export type IoTBoxSettingRowDelDialogResponse = {};

/**
 * IoTBox設定 削除ダイアログ
 * @param props
 * @returns
 */
const IoTBoxSettingRowDelDialog: React.FC<IoTBoxSettingRowDelDialogProps> = (props: IoTBoxSettingRowDelDialogProps) => {
  const { t } = useTranslation();

  const tableBaseStyle = TableUseStyle();
  const pageStyle = IoTBoxSettingStyle();

  const [isOpen, setOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);

  useEffect(() => { }, []);

  const handleDialogClose = () => {
    console.debug('handleDialogClose()');
    setOpen(false);
    setMode(false);
  };

  /**
   * 削除登録状態更新処理呼び出し
   */
  const delBtnAction = () => {
    console.debug(['--- delBtnAction ---', props.item?.IMSI_NO]);

    deleteIoTSet(props.item ? props.item.IMSI_NO : '').then((status: number) => {
      console.debug(['status', status]);
      if (status == ApiResponseCode.SUCCESS) {
        // 削除登録要求をレコード追加 非同期待ち
        setOpen(false);
        setMode(true);
      }
    });
  };

  console.debug(['- 画面描画開始 -', 'mode:', mode, props.item?.IMSI_NO]);
  return (
    <>
      <Dialog
        open={isOpen}
        fullWidth
        maxWidth="sm"
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">{t('IoTBoxSettingRowDelDialog.IoTBox削除', 'IoTBox削除')}</DialogTitle>
        <DialogContent>
          {`IMSI「${props.item?.IMSI_NO}」
          ${t('IoTBoxSettingRowDelDialog.IoTBoxの登録を削除しますか？', 'IoTBoxの登録を削除しますか？')}`}
        </DialogContent>

        <DialogActions>
          <Button
            className={pageStyle.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleDialogClose}
          >
            {t('IoTBoxSettingRowDelDialog.キャンセル', 'キャンセル')}
          </Button>
          <Button
            disabled={props.item?.IMSI_NO == undefined}
            className={pageStyle.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={(e) => {
              delBtnAction();
            }}
          >
            {t('IoTBoxSettingRowDelDialog.削除', '削除')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default IoTBoxSettingRowDelDialog;
